import { DITypes, IUserProfile, LocalStorageKeys } from "@/core/@types/types";
import { IUserProfileStorageMixin } from "./UserProfileStorageMixin";
import { inject, injectable } from "inversify";
import type { IStorage } from "./Storage";
import "reflect-metadata";

@injectable()
export default class UserProfileStorageMixin
  implements IUserProfileStorageMixin
{
  @inject(DITypes.STORAGE)
  storage!: IStorage;

  handleGetUserProfile(): IUserProfile | null {
    const userProfile = this.storage.get<IUserProfile>(
      LocalStorageKeys.UserProfile
    );

    return userProfile || null;
  }
}
